<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24">
          <Tabs :value="currentRoute" @on-click="changeRouter">
            <TabPane name="shutdownlist" label="一键关停"></TabPane>
            <TabPane name="shutdownadd" label="创建一键关停" v-if="currentRoute === 'shutdownadd'"></TabPane>
            <TabPane name="shutdowndetail" label="关闭计划详情" v-if="currentRoute === 'shutdowndetail'"></TabPane>
          </Tabs>
        </Col>
      </Row>
      <div class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'ShutdownDefault',
  data() {
    return {
      currentRoute: '',
      access: this.$store.state.accessAuth
    }
  },
  methods: {
    changeRouter(name) {
      this.$router.replace({ name })
    },
    getCurrent() {
      this.currentRoute = this.$route.name
      if (this.$route.name === 'shutdown') this.changeRouter('shutdownlist')
    }
  },
  watch: {
    $route: {
      handler() {
        this.getCurrent()
      },
      deep: true
    }
  },
  created() {
    this.getCurrent()
  }
}
</script>
